export default __webpack_public_path__ + "static/media/banner-2.f4328763.png";